import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {Button, Col, Container, Row} from "reactstrap";
import {HasPermission} from "../HasPermission";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {enumFormatter, getEnumOptions} from "../../utils/helper";
import {enums} from "../../Enums";

const qs = require('qs');

import _ = require("lodash");

const IWindow: IWindow = (window as IWindow);

export class CollationResultFormData {
    @observable election_id = null;
    @observable party_id = null;
    @observable number_of_votes = null;
    @observable candidate_id = null;
    @observable collation_type = null;
    @observable local_government_area_id = null;
    @observable election_position_id = null;
    @observable ward_id = null;
    @observable state_id = null;
    @observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable state_constituency_id = null;
    @observable level = null;
    @observable user_level = IWindow.initialState.user.level;
}

export class CollationResultForm extends CrudForm {
    modelName = 'CollationResult';

    getCollationsByLevel() {
        let levels: any [];
        if (IWindow.initialState.user.level === 'party') {
            levels = ['state', 'senatorial_district', 'federal_constituency', 'state_constituency', 'lga', 'ward', 'party'];
        }
        if (IWindow.initialState.user.level === 'state') {
            levels = ['state', 'senatorial_district', 'federal_constituency', 'state_constituency', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'senatorial_district') {
            levels = ['senatorial_district', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'federal_constituency') {
            levels = ['federal_constituency', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'state_constituency') {
            levels = ['state_constituency', 'ward'];
        }
        if (IWindow.initialState.user.level === 'lga') {
            levels = ['lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'ward') {
            this.formStore.setValue('collation_type', 'ward');
        }

        return _.filter(getEnumOptions(enums.userLevel), (level: any) => {
            return levels.includes(level.value);
        });
    }

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency'])
            .includes(this.formStore.getValue('collation_type')))
        && this.formStore.getValue('collation_type') !== 'party' ?

            <Field
                key={'form_collation_state_id_' +
                this.formStore.getValue('collation_type') +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.formStore.getValue('election_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={() => {
                    this.formStore.setValue('senatorial_district_id', null);
                    this.formStore.setValue('federal_constituency_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('state_constituency_id', null);
                    this.formStore.setValue('ward_id', null);
                }}
            />
            : '';
    };

    lgaDropDown() {
        return ((['ward', 'lga']).includes(this.formStore.getValue('collation_type'))) ?
            <Field
                key={'form_local_government_area_id_' +
                this.formStore.getValue('collation_type') +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id') +
                this.formStore.getValue('state_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('senatorial_district_id') +
                this.formStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.formStore.getValue('election_id'),
                            state_id: this.formStore.getValue('state_id'),
                            senatorial_district_id: this.formStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            party_id: this.formStore.getValue('party_id'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={() => {
                    this.formStore.setValue('ward_id', null);
                }}
            />
            : '';
    }

    wardsDropDown() {
        return (this.formStore.getValue('collation_type') === 'ward') && <Field
            key={'form_ward_id_' +
            this.formStore.getValue('collation_type') +
            this.formStore.getValue('election_id') +
            this.formStore.getValue('party_id') +
            this.formStore.getValue('election_position_id') +
            this.formStore.getValue('level') +
            this.formStore.getValue('candidate_id') +
            this.formStore.getValue('state_id') +
            this.formStore.getValue('senatorial_district_id') +
            this.formStore.getValue('federal_constituency_id') +
            this.formStore.getValue('local_government_area_id')
            }
            name="ward_id"
            placeholder="Select Ward"
            component={Select}
            loadOptions={() => {
                return api.ward.getListAction({
                    filters: {
                        state_id: this.formStore.getValue('state_id'),
                        local_government_area_id: this.formStore.getValue('local_government_area_id'),
                        state_constituency_id: this.formStore.getValue('state_constituency_id'),
                        election_position_id: this.formStore.getValue('election_position_id'),
                        level: this.formStore.getValue('level'),
                        candidateIds: this.formStore.getValue('candidate_id') ?
                            [this.formStore.getValue('candidate_id')] : null,
                        party_id: this.formStore.getValue('party_id'),
                        user_level: this.formStore.getValue('user_level')
                    }
                });
            }}
            store={this.formStore}

        />;
    }

    senatorialDistrictDropDown() {
        return ((['senatorial_district', 'lga', 'ward'])
                .includes(this.formStore.getValue('collation_type')) &&
            this.formStore.getValue('level') === 'senatorial_district') ?
            <Field
                key={'form_collation_senatorial_district_' +
                this.formStore.getValue('collation_type') +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                }}
            />
            : '';
    }

    federalConstituencyDropDown() {
        return (
            (['federal_constituency', 'lga', 'ward'])
                .includes(this.formStore.getValue('collation_type')) &&
            this.formStore.getValue('level') === 'federal_constituency') ?
            <Field
                key={
                    'form_collation_federal_constituency_id_' +
                    this.formStore.getValue('collation_type') +
                    this.formStore.getValue('election_id') +
                    this.formStore.getValue('party_id') +
                    this.formStore.getValue('election_position_id') +
                    this.formStore.getValue('level') +
                    this.formStore.getValue('candidate_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);

                }}
            />
            : '';
    }

    stateConstituencyDropDown() {
        return ((['state_constituency', 'ward'])
                .includes(this.formStore.getValue('collation_type')) &&
            this.formStore.getValue('level') === 'state_constituency') ?
            <Field
                key={'form_collation_state_constituency_id_' +
                this.formStore.getValue('collation_type') +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);

                }}
            />
            : '';
    }


    renderFields() {
        return (
            <>
                <Field
                    key={'form-collation-type'}
                    placeholder="Collation Type"
                    name="collation_type"
                    component={Select}
                    required={true}
                    options={this.getCollationsByLevel()}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('party_id', null);
                        this.formStore.setValue('candidate_id', null);
                        this.formStore.setValue('election_position_id', null);
                        this.formStore.setValue('state_id', null);
                        this.formStore.setValue('senatorial_district_id', null);
                        this.formStore.setValue('federal_constituency_id', null);
                        this.formStore.setValue('local_government_area_id', null);
                        this.formStore.setValue('state_constituency_id', null);
                        this.formStore.setValue('ward_id', null);
                    }}
                />

                <Field
                    key={'form-election' + this.formStore.getValue('collation_type')}
                    name="election_id"
                    placeholder="Select Election"
                    component={Select}
                    required={true}
                    loadOptions={() => {
                        return api.election.getListAction({
                            filters: {
                                party_id: IWindow.initialState.user.party_id,
                                collation_type: this.formStore.getValue('collation_type'),
                            }
                        });
                    }}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('party_id', null);
                        this.formStore.setValue('candidate_id', null);
                        this.formStore.setValue('election_position_id', null);
                        this.formStore.setValue('state_id', null);
                        this.formStore.setValue('senatorial_district_id', null);
                        this.formStore.setValue('federal_constituency_id', null);
                        this.formStore.setValue('local_government_area_id', null);
                        this.formStore.setValue('state_constituency_id', null);
                        this.formStore.setValue('ward_id', null);
                    }}
                />

                {this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_party_id_' + this.formStore.getValue('election_id')}
                        name="party_id"
                        placeholder="Select Party"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
                        loadOptions={() => {
                            return api.party.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    include_competitor_party: 1
                                }
                            }).then((data: any) => {
                                return data.data;
                            });
                        }}
                        store={this.formStore}
                        onChange={() => {
                            this.formStore.setValue('candidate_id', null);
                            this.formStore.setValue('election_position_id', null);
                        }}
                    /> : ''
                }

                {this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_election_position_id_' +
                        this.formStore.getValue('collation_type') +
                        this.formStore.getValue('election_id') +
                        this.formStore.getValue('party_id')
                        }
                        name="election_position_id"
                        placeholder="Select Position"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
                        loadOptions={() => {
                            return api.electionPosition.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    party_id: this.formStore.getValue('party_id'),
                                    collation_type: this.formStore.getValue('collation_type'),
                                    user_levels: this.formStore.getValue('user_level')
                                }
                            });
                        }}
                        returnObject={true}
                        extraKey={'level'}
                        store={this.formStore}
                        onChange={(item: any) => {
                            this.formStore.setValue('level', null);
                            if (item) {
                                this.formStore.setValue('level', item.extraKey);
                            }
                            this.formStore.setValue('candidate_id', null);
                            this.formStore.setValue('state_id', null);
                            this.formStore.setValue('senatorial_district_id', null);
                            this.formStore.setValue('federal_constituency_id', null);
                            this.formStore.setValue('local_government_area_id', null);
                            this.formStore.setValue('state_constituency_id', null);
                            this.formStore.setValue('ward_id', null);
                        }}
                    />
                    : ''
                }

                {this.formStore.getValue('party_id') &&
                this.formStore.getValue('election_id') ?
                    <Field
                        key={'form_election_candidate' +
                        this.formStore.getValue('collation_type') +
                        this.formStore.getValue('party_id') +
                        this.formStore.getValue('election_id') +
                        this.formStore.getValue('election_position_id')
                        }
                        name="candidate_id"
                        placeholder="Select Candidate"
                        component={Select}
                        disabled={!this.formStore.getValue('party_id')}
                        required={true}
                        returnObject={true}
                        loadOptions={() => {
                            return api.candidate.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    party_id: this.formStore.getValue('party_id'),
                                    election_position_id: this.formStore.getValue('election_position_id'),
                                    election_position_level: this.formStore.getValue('level')
                                }
                            });
                        }}
                        store={this.formStore}
                        onChange={(candidate: any) => {
                            this.formStore.setValue('state_id', null);
                            this.formStore.setValue('senatorial_district_id', null);
                            this.formStore.setValue('federal_constituency_id', null);
                            this.formStore.setValue('local_government_area_id', null);
                            this.formStore.setValue('state_constituency_id', null);
                            this.formStore.setValue('ward_id', null);
                        }}
                    />
                    : ''
                }

                {
                    this.formStore.getValue('level') ?
                        <>
                            {this.stateDropDown()}
                            {this.senatorialDistrictDropDown()}
                            {this.federalConstituencyDropDown()}
                            {this.lgaDropDown()}
                            {this.stateConstituencyDropDown()}
                            {this.wardsDropDown()}

                        </> : ''
                }

                <Field
                    key="form-votes"
                    label="Number of votes"
                    name="number_of_votes"
                    type="number"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

            </>
        );
    }
}

export class CollationResultFilterForm {
    @observable election_type_id = '';
    @observable election_id = '';
    @observable election_position_id = '';
    @observable party_id = '';
    @observable level = '';
    @observable state_id = '';
    @observable local_government_area_id = '';
    @observable ward_id = '';
    @observable senatorial_district_id = '';
    @observable federal_constituency_id = '';
    @observable state_constituency_id = '';
    @observable candidate_id = null;
    @observable party_competitor_party_result = 1;
    @observable user_level = IWindow.initialState.user.level;
    @observable collation_type = null;
}

export class CollationResultList extends CrudList {
    modelName = 'CollationResult';
    @observable candidateResult: any = null;
    @observable numberOfVotes: any = null;
    @observable level: string = '';
    @observable party_id = IWindow.initialState.user.party_id;
    collation_levels = [];

    constructor(props: any) {
        super(props);
        this.handleExport = this.handleExport.bind(this);
    }

    handleExport = () => {
        let search = {
            filters: this.filterFormStore.data,
            export: true
        };
        window.location.href = '/api/collation-results?' + qs.stringify(search);
    };

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency'])
            .includes(this.filterFormStore.getValue('level')))
        && this.filterFormStore.getValue('collation_type') !== 'party' ?
            <Col md={2}>
                <Field
                    key={'filter_collation_state_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="state_id"
                    placeholder="Select State"
                    component={Select}
                    loadOptions={() => {
                        return api.state.getListAction({
                            filters: {
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={() => {
                        this.filterFormStore.setValue('senatorial_district_id', null);
                        this.filterFormStore.setValue('federal_constituency_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                        this.filterFormStore.setValue('state_constituency_id', null);
                        this.filterFormStore.setValue('ward_id', null);
                        this.getCandidateResultDetails();
                    }}
                />
            </Col> : '';
    };

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2}>
                <Field
                    key={'filter_collation_senatorial_district_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                        this.getCandidateResultDetails();
                    }}
                />
            </Col> : '';
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2}>
                <Field
                    key={
                        'filter_collation_federal_constituency_id_' +
                        this.filterFormStore.getValue('election_type_id') +
                        this.filterFormStore.getValue('election_id') +
                        this.filterFormStore.getValue('party_id') +
                        this.filterFormStore.getValue('election_position_id') +
                        this.filterFormStore.getValue('level') +
                        this.filterFormStore.getValue('candidate_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                        this.getCandidateResultDetails();
                    }}
                />
            </Col> : '';
    }

    lgaDropDown() {
        return ((!(['ward', 'state_constituency'])
            .includes(this.filterFormStore.getValue('level'))) && (['ward', 'lga'])
            .includes(this.filterFormStore.getValue('collation_type'))) ? <Col md={2}>
            <Field
                key={'local_government_area_id_' +
                this.filterFormStore.getValue('election_type_id') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('party_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('candidate_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                [this.filterFormStore.getValue('candidate_id')] : null,
                            party_id: this.filterFormStore.getValue('party_id'),
                            user_level: this.filterFormStore.getValue('user_level')
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('ward_id', null);
                    this.getCandidateResultDetails();
                }}
            />
        </Col> : '';
    };

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2}>
                <Field
                    key={'filter_collation_state_constituency_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.getCandidateResultDetails();
                    }}
                />
            </Col> : '';
    }

    wardsDropDown() {
        return (this.filterFormStore.getValue('collation_type') === 'ward') && <Col md={2}>
            <Field
                key={'filter_ward_id_' +
                this.filterFormStore.getValue('election_type_id') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('party_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('candidate_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id') +
                this.filterFormStore.getValue('local_government_area_id')
                }
                name="ward_id"
                placeholder="Select Ward"
                component={Select}
                loadOptions={() => {
                    return api.ward.getListAction({
                        filters: {
                            state_id: this.filterFormStore.getValue('state_id'),
                            local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                            state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                [this.filterFormStore.getValue('candidate_id')] : null,
                            party_id: this.filterFormStore.getValue('party_id'),
                            user_level: this.filterFormStore.getValue('user_level')
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.getCandidateResultDetails();
                }}
            />
        </Col>;
    }

    colums() {
        return [
            {
                name: "created_user.name",
                label: "Uploaded by",
            },
            {
                name: "candidate.name",
                label: "Candidate",
            },
            {
                name: "party.name",
                label: "Party",
            },
            {
                name: "collation_type",
                label: "Collation Type",
                formatter: enumFormatter(enums.userLevel)
            },

            {
                name: "collation_type",
                label: "Collation",
                formatter: (value: any, item: any) => {
                    if (value === 'lga') {
                        return item.local_government_area.name;
                    } else if (value === 'state') {
                        return item.state.name;
                    } else if (value === 'senatorial_district') {
                        return item.senatorial_district.name;
                    } else if (value === 'federal_constituency') {
                        return item.federal_constituency.name;
                    } else if (value === 'state_constituency') {
                        return item.state_constituency.name;
                    } else if (value === 'ward') {
                        return item.ward.name + '/' + item.ward.local_government_area.name;
                    }
                },
            },

            {
                name: "collation_type",
                label: "State",
                formatter: (value: any, item: any) => {
                    if (value === 'lga') {
                        return item.local_government_area.state.name;
                    } else if (value === 'state') {
                        return item.state.name;
                    } else if (value === 'senatorial_district') {
                        return item.senatorial_district.state.name;
                    } else if (value === 'federal_constituency') {
                        return item.federal_constituency.state.name;
                    } else if (value === 'state_constituency') {
                        return item.state_constituency.state.name;
                    } else if (value === 'ward') {
                        return item.ward.state.name;
                    }
                },
            },

            {
                name: "created_at",
                label: "Datetime",
            },
            {
                name: "number_of_votes",
                label: "Results",
            },
        ];
    }

    // TODO: Module name should be dynamic
    actions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any, item: any) => {
                return (
                    <>
                        <HasPermission module='collation_result' permission="edit">
                            <Button color="grid" onClick={() => this.goToDetail(item)} size="sm"
                                    className="btn-edit"><span className="icon-edit"/></Button>
                        </HasPermission>
                    </>
                );
            },
            style: {width: 140, textAlign: 'center'},
        }
    }

    idColumn() {
        return '';
    }

    goToDetail(item: any) {
        window.location.href = '/collation-results/' + item.id;
    }

    getCandidateResultDetails() {
        this.numberOfVotes = null;
        let filters = {
            ...this.filterFormStore.data
        };
        this.filterFormStore.getValue('candidate_id') && api.collationResult.getListAction({
            filters: filters,
            count: true,
        }).then((data: any) => {
            this.numberOfVotes = data;
        });
    }

    setCandidate(candidate: any) {
        this.candidateResult = candidate;
    }

    renderTable() {
     //   if (this.filterFormStore.getValue('election_id') && this.filterFormStore.getValue('collation_type')) {
            return super.renderTable();
     //   }
     //   return <>{'Please select election & collation first!'}</>;
    }

    getCollationsByLevel() {
        let levels: any [];
        if (IWindow.initialState.user.level === 'party') {
            levels = ['state', 'senatorial_district', 'federal_constituency', 'state_constituency', 'lga', 'ward', 'party'];
        }
        if (IWindow.initialState.user.level === 'state') {
            levels = ['state', 'senatorial_district', 'federal_constituency', 'state_constituency', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'senatorial_district') {
            levels = ['senatorial_district', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'federal_constituency') {
            levels = ['federal_constituency', 'lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'state_constituency') {
            levels = ['state_constituency', 'ward'];
        }
        if (IWindow.initialState.user.level === 'lga') {
            levels = ['lga', 'ward'];
        }
        if (IWindow.initialState.user.level === 'ward') {
            this.filterFormStore.setValue('collation_type', 'ward');
        }

        return _.filter(getEnumOptions(enums.userLevel), (level: any) => {
            return levels.includes(level.value);
        });
    }

    renderFilters() {
        return (
            <Container>
                <Row className="form-row">
                    {this.getCollationsByLevel ?
                        <Col md={2}>
                            <Field
                                key={'filter-collation-type'}
                                placeholder="Collation Type"
                                name="collation_type"
                                component={Select}
                                required={true}
                                options={this.getCollationsByLevel()}
                                store={this.filterFormStore}
                                onChange={() => {
                                    this.getCandidateResultDetails();
                                }}
                            />
                        </Col>
                        : ''
                    }

                    <Col md={2}>
                        <Field
                            name="election_type_id"
                            placeholder="Select Election Type"
                            component={Select}
                            required={true}
                            loadOptions={api.electionType.getListAction}
                            store={this.filterFormStore}
                            onChange={() => {
                                this.filterFormStore.setValue('election_id', null);
                            }}
                        />
                    </Col>

                    <Col md={2}>
                        <Field
                            key={'filter' + this.filterFormStore.getValue('election_type_id')}
                            placeholder="Select Election"
                            name="election_id"
                            component={Select}
                            required={true}
                            loadOptions={() => {
                                return api.election.getListAction({
                                    filters: {
                                        election_type_id: this.filterFormStore.getValue('election_type_id'),
                                        party_id: this.party_id,
                                    }
                                });
                            }}
                            store={this.filterFormStore}
                            onChange={() => {
                                this.filterFormStore.setValue('party_id', null);
                                this.filterFormStore.setValue('candidate_id', null);
                            }}
                        />
                    </Col>

                    {this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                                key={'party_id_' + this.filterFormStore.getValue('election_id')}
                                name="party_id"
                                placeholder="Select Party"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('election_id')}
                                required={true}
                                loadOptions={() => {
                                    return api.party.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            include_competitor_party: 1
                                        }
                                    }).then((data: any) => {
                                        return data.data;
                                    });
                                }}
                                store={this.filterFormStore}
                                onChange={() => {
                                    this.filterFormStore.setValue('candidate_id', null);
                                    this.filterFormStore.setValue('election_position_id', null);
                                }}
                            />
                        </Col> : ''
                    }

                    {this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                                key={'election_position_id_' +
                                this.filterFormStore.getValue('election_id') +
                                this.filterFormStore.getValue('party_id') +
                                this.filterFormStore.getValue('collation_type')

                                }
                                name="election_position_id"
                                placeholder="Select Position"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('election_id')}
                                required={true}
                                loadOptions={() => {
                                    return api.electionPosition.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            party_id: this.filterFormStore.getValue('party_id'),
                                            collation_type: this.filterFormStore.getValue('collation_type'),
                                            user_levels: this.filterFormStore.getValue('user_level')
                                        }
                                    });
                                }}
                                returnObject={true}
                                extraKey={'level'}
                                store={this.filterFormStore}
                                onChange={(item: any) => {
                                    this.filterFormStore.setValue('level', null);
                                    if (item) {
                                        this.filterFormStore.setValue('level', item.extraKey);
                                    }
                                    this.filterFormStore.setValue('candidate_id', null);
                                    this.filterFormStore.setValue('state_id', null);
                                    this.filterFormStore.setValue('senatorial_district_id', null);
                                    this.filterFormStore.setValue('federal_constituency_id', null);
                                    this.filterFormStore.setValue('local_government_area_id', null);
                                    this.filterFormStore.setValue('state_constituency_id', null);
                                    this.filterFormStore.setValue('ward_id', null);
                                }}
                            />
                        </Col> : ''
                    }

                    {this.filterFormStore.getValue('party_id') && this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                                key={'election_candidate' +
                                this.filterFormStore.getValue('party_id') +
                                this.filterFormStore.getValue('election_id') +
                                this.filterFormStore.getValue('election_position_id')
                                }
                                name="candidate_id"
                                placeholder="Select Candidate"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('party_id')}
                                required={true}
                                returnObject={true}
                                loadOptions={() => {
                                    return api.candidate.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            party_id: this.filterFormStore.getValue('party_id'),
                                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                                        }
                                    });
                                }}
                                store={this.filterFormStore}
                                onChange={(candidate: any) => {
                                    this.setCandidate(candidate);
                                    this.getCandidateResultDetails();
                                }}
                            />
                        </Col> : ''
                    }

                </Row>

                <Row className="form-row">
                    {
                        this.filterFormStore.getValue('level') ?
                            <>
                                {this.stateDropDown()}

                                {this.senatorialDistrictDropDown()}

                                {this.federalConstituencyDropDown()}

                                {this.filterFormStore.getValue('level') !== 'state_constituency' ? this.lgaDropDown() : ''}

                                {this.stateConstituencyDropDown()}

                                {this.wardsDropDown()}
                            </> : ''
                    }
                    <Col md={2} className="grid-search">
                        {this.renderSearch()}
                    </Col>

                    {this.filterFormStore.getValue('election_id') && <Col md={1} className="grid-search">
                        <button className="btn btn-dark" onClick={this.handleExport}>Export</button>
                    </Col>}

                    {this.candidateResult && this.filterFormStore.getValue('candidate_id') && this.numberOfVotes ?
                        <Col md={2} key={
                            'candidate_id_votes' + this.filterFormStore.getValue('candidate_id') +
                            this.filterFormStore.getValue('state_id') +
                            this.filterFormStore.getValue('local_government_area_id') +
                            this.filterFormStore.getValue('ward_id') +
                            this.filterFormStore.getValue('senatorial_district_id') +
                            this.filterFormStore.getValue('federal_constituency_id') +
                            this.filterFormStore.getValue('state_constituency_id') +
                            this.filterFormStore.getValue('collation_type')
                        }>
                            <div className={'form-group'}>
                                <div className={'font-weight-bold'}><span
                                    className={'icon-users'}/> {this.candidateResult.label}</div>
                                <div>
                                    Total Votes:
                                    <span className={'text-primary'}> {this.numberOfVotes}</span>
                                </div>
                            </div>
                        </Col> : ''
                    }

                </Row>
            </Container>
        );
    }
}

export class CollationResultPage extends CrudPage {
    modelName = 'CollationResult';

    constructor(props: any) {
        super(props);
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/CollationResultPage.tsx